import { Fragment } from "react";
import { classNames } from "primereact/utils";
import { IFormSegment } from "./formTemplateParser";
import styles from "./PreReservationFormFields.module.scss";

interface IPreReservationFormFieldsProps {
  segments: IFormSegment[];
  contextValues: Record<string, string>;
  answers: string[];
  onAnswerChange: (index: number, value: string) => void;
  isInvalid: (index?: number) => boolean;
}

/** A form's text with its context values filled in and its fields editable. */
export const PreReservationFormFields = ({
  segments,
  contextValues,
  answers,
  onAnswerChange,
  isInvalid,
}: IPreReservationFormFieldsProps) => (
  <>
    {segments.map((segment, index) => {
      switch (segment.type) {
        case "break":
          return <br key={index} />;
        case "context":
          return (
            <span key={index} className={styles.context}>
              {contextValues[segment.value] ?? ""}
            </span>
          );
        case "input":
          return (
            <input
              key={index}
              className={classNames(styles.input, {
                [styles.invalid]: isInvalid(segment.inputIndex),
              })}
              value={answers[segment.inputIndex ?? -1] ?? ""}
              onChange={(e) =>
                onAnswerChange(segment.inputIndex ?? 0, e.target.value)
              }
            />
          );
        case "textarea":
          return (
            <textarea
              key={index}
              rows={3}
              className={classNames(styles.textarea, {
                [styles.invalid]: isInvalid(segment.inputIndex),
              })}
              value={answers[segment.inputIndex ?? -1] ?? ""}
              onChange={(e) =>
                onAnswerChange(segment.inputIndex ?? 0, e.target.value)
              }
            />
          );
        default:
          return <Fragment key={index}>{segment.value}</Fragment>;
      }
    })}
  </>
);
